import styled from 'styled-components';

export const JoinCallMask = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 70px);
    position: relative;
    background-color: rgba(0,0,0,0.9);
    top: 0;
    width: 100vw;
    
    > p {
    color: white;
    position: relative;
    z-index: 4;
    font-family: Open Sans;
    font-weight: 300;
    font-size: 13px;
    margin-left: 25px;
    margin-right: 25px;
    text-align: center;
        > a {
            color: rgb(150,190,255);
        }
    }
    
    > div.maskTint {
        background-image: url('https://firebasestorage.googleapis.com/v0/b/cyno-corporate-test.appspot.com/o/iStock-508387030_small.jpg?alt=media&token=bc7f950d-99be-4a1d-b188-65828167aa74');
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-repeat:no-repeat;
        background-position: center center;
    }

    > div.maskImage {
        background-color: rgba(0, 0, 10, 0.7);
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }

    > button.text {
        position: relative;
        z-index: 4;
        background-color: #ffcd00;
        border: 3px solid rgba(0,0,0,0.1);
        border-radius: 50px;
        height: 50px;
        font-size: 20px;
        color: rgba(0,0,0,0.6);
        padding: 0px 20px;
        margin-left: 10px;
        margin-right: 10px;
        box-shadow: 2px 2px 15px rgba(0,0,0,0.3);
        &:hover {
            backgorund-color: rgba(0,0,255, 0.5);
        }
    }
`;


// WEBPACK FOOTER //
// ./src/js/components/VideoUI/JoinCallMask.jsx